// extracted by mini-css-extract-plugin
export default {"wrapper":"LinkWordButton_wrapper__Tgt1y","button":"LinkWordButton_button__lRP9g","withIcon":"LinkWordButton_withIcon__amwHj","text":"LinkWordButton_text__pKoCa"};